// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__erCTe","errorLogs":"EditorFooter_errorLogs__2GJ7Z"};